import { gsap } from 'gsap';
import { Flip } from 'gsap/Flip.js';
import { Draggable } from 'gsap/Draggable.js';

gsap.registerPlugin(Flip);
gsap.registerPlugin(Draggable);

export default class Carousel {
  constructor(root) {
    this.carousel = root;

    this.init();
  }

  init() {
	const carousel = this.carousel;
	const prev = carousel.querySelector(".js-carousel-prev");
	const next = carousel.querySelector(".js-carousel-next");
	const carouselContainer = carousel.querySelector(".js-carousel-container");
	let carouselItems = Array.from(carousel.querySelectorAll(".js-carousel-item"));

	function setInitialPosition() {
		carouselItems.unshift(carouselItems.pop());
		carouselContainer.innerHTML = "";
		carouselItems.forEach((item) => carouselContainer.appendChild(item));

		carousel.classList.remove("is-loading");
	}

	function moveCarousel(direction) {
		const state = Flip.getState(carouselItems, prev, next);
		if (direction === "NEXT") {
			carousel.classList.add('direction-next');
			carouselItems.push(carouselItems.shift())
		} else {
			carousel.classList.remove('direction-next');
			carouselItems.unshift(carouselItems.pop());
		}

		carouselContainer.innerHTML = "";
		carouselItems.forEach((item) => carouselContainer.appendChild(item));

		Flip.from(state, {
			props: "transform, opacity",
			duration: .75,
			ease: "power1.out"
		});
	}

	setInitialPosition();

	new Draggable(document.createElement("div"), {
		trigger: carousel,
		type: "x",
		minimumMovement: 80,
		allowContextMenu: true,
		onDragStart: function () {
			this.getDirection() === "left" ? moveCarousel("NEXT") : moveCarousel("PREV");
		}
	});

	prev.addEventListener("click", () => moveCarousel("PREV"));
	next.addEventListener("click", () => moveCarousel("NEXT"));
  }
}
